module.exports = __webpack_public_path__ + "static/storybook-site-4dd2daa5d058b4eaa6b545381fee5deb.png";